<template>
  <el-select
    ref="select"
    :value="value"
    :disabled="disabled"
    :placeholder="placeholder"
    @change="change"
    :filterable="filterable"
    :loading="loading"
    style="width:100%"
    :collapse-tags="collapseTags"
    :multiple="multiple"
    :clearable="clearable"
    size="mini"
  >
    <el-option
      v-for="item in list"
      :key="item[idKey]"
      :label="item[labelKey]"
      :value="item[idKey]"
      :disabled="disabledItem ? disabledValue == item[idKey] : false"
      v-show="!item[disabledKey]"
    ></el-option>
  </el-select>
</template>
<script>
export default {
  props: {
    getDataFunc: {
      type: Function,
      default: null,
    },
    value: {},
    filterable: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    disabledItem: {
      type: Boolean,
      default: false,
    },
    disabledValue: {
      type: Number,
      default: undefined,
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    idKey: {
      type: String,
      default: "id",
    },
    labelKey: {
      type: String,
      default: "name",
    },
    disabledKey: {
      type: String,
      default: "isDisabled",
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    collapseTags: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      loading: false,
    };
  },
  created() {
    this.getData();
  },
  watch:{
    value(){
      if(this.value){
      let data =""
      this.list.forEach(e=>{if(e[this.idKey]==this.value) data=e }) 
      this.$emit("input", this.value,data,false);
      // this.$emit("change", this.value,data,false);
      // this.$emit("select", this.value,data,false);
      }
    }
  },
  methods: {
    getData() {
      // 
      if (!this.getDataFunc) {
        alert("请指定get-data-func属性！");
        return;
      }
      this.loading = true;
      return this.getDataFunc()
        .then((res) => {
          this.list = res.Data;
          this.loading = false;
          // 
          return res;
        })
        .catch((err) => {
          
        });
    },
    change(value) {
      let data =""
      this.list.forEach(e=>{if(e[this.idKey]==value) data=e }) 
      this.$emit("input", value,data,true);
      this.$emit("change", value,data,true);
      this.$emit("select", value,data,true);
    },
  },
};
</script>

